import { Injectable } from '@angular/core';
import { TeamnoteApiService } from '../../api/teamnote-api.service';
import { TeamNoteApiConstant } from '../../constants/api.constant';
import { without, union, each, remove, find, sortBy } from 'lodash';
import { Sticker, StickerCategory } from '../../models/sticker';
import { BehaviorSubject } from 'rxjs';
import { FileFactoryService } from '../file-factory/file-factory.service';

@Injectable({
  providedIn: 'root'
})
export class StickerService {

  recentStickers: Sticker[] = []
  recentStickers$: BehaviorSubject<Sticker[]> = new BehaviorSubject<Sticker[]>([])

  constructor(
    private _teamnoteApiService: TeamnoteApiService,
    private _fileFactoryService: FileFactoryService
  ) { }

  getStickersCategories(success: Function, failure: Function): void {
    let url = TeamNoteApiConstant.STICKER.CATEGORIES;
    let param = {

    }

    this._teamnoteApiService.callApi(
      url,
      param,
      (resp: StickerCategory[]) => {
        resp.sort((a, b) => {
          return a.order - b.order;
        })

        each(resp, (cat) => {
          this._fileFactoryService.getFileByAttachmentId(
            cat.tray_image_id,
            (imageUrl) => {
              cat.iconBgUrl = imageUrl
            },
            (err) => {},
            false,
            false,
            true
          )
        })

        success(resp)
      },
      failure
    );
  }

  getStickerByCategory(categoryId: string, success: Function, failure: Function): void {
    let url = TeamNoteApiConstant.STICKER.STICKERS;
    let param = {
      category_id: categoryId
    }

    this._teamnoteApiService.callApi(
      url,
      param,
      (resp: Sticker[]) => {

        resp = sortBy(resp, ['order'])

        success(resp)
      },
      failure
    );
  }

  updateRecentStickerSubject(): void {
    this.recentStickers$.next(this.recentStickers);
  }
  addStickerToRecents(sticker: Sticker): void {
    // let originalSticker = find(this.recentStickers, {attachment_id: sticker.attachment_id});
    this.recentStickers = without(this.recentStickers, sticker)
    this.recentStickers = union([sticker], this.recentStickers)
    this.updateRecentStickerSubject();
  }

  getRecentStickers(): Sticker[] {
    return this.recentStickers;
  }
}
